import type { ReactNode } from 'react'
import { cx } from '../cx'
import s from './Text.module.css'

export type Tone = 'default' | 'muted' | 'faint' | 'accent' | 'warn' | 'bad'

/**
 * Any run of text that isn't a heading. One size does most of the work; tone and weight make the hierarchy.
 * `mono` is for small labels, times, codes and numbers, never for sentences.
 */
export function Text(props: {
  children: ReactNode
  tone?: Tone
  size?: 'xs' | 'sm' | 'md' | 'lg'
  weight?: 'body' | 'strong'
  mono?: boolean
  as?: 'p' | 'span' | 'div'
  /** Cut to one line with an ellipsis. */
  truncate?: boolean
  nowrap?: boolean
}) {
  const Tag = props.as ?? 'p'
  return (
    <Tag
      className={cx(
        s.text,
        s[`tone-${props.tone ?? 'default'}`],
        s[`size-${props.size ?? 'md'}`],
        props.weight === 'strong' && s.strong,
        props.mono && s.mono,
        props.truncate && s.truncate,
        props.nowrap && s.nowrap,
      )}
    >
      {props.children}
    </Tag>
  )
}
